import {Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR} from '@angular/forms';

interface Item {
  label: string;
  value: string;
}

/**
 * Use this component to create a drop-down list with several options
 */
@Component({
  selector: 'clo-input-select',
  templateUrl: './select-input.html',
  styleUrls: ['./input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CloInputSelect),
      multi: true
    }
  ]
})
export class CloInputSelect implements OnInit, ControlValueAccessor {

  /**
   * Object value for the dropdown selected option
   * {label: string, value: any}
   */
  @Input() selectedOption: Item;

  /**
   * String value for the ID of the drop down
   */
  @Input() dropdownID = 'customDropdown';

  /**
   * String value for input name
   */
  @Input() inputName;

  /**
   * Objects for the drop down
   * {label: string, value: any}
   */
  @Input() objects: Item[];

  /**
   * String value for the title of the dropdown
   */
  @Input() title: string;

  /**
   * String value for the placeholder text of the dropdown
   */
  @Input() placeholder: string;

  /**
   * String value for the error message
   */
  @Input() errorMessage = '';

  /**
   * Boolean value for whether the field is required
   *
   */
  @Input() required: boolean;

  /**
   * Boolean value for whether selectedOption is a default value and should be the primary color.
   *
   */
  @Input() isDefaultValue = false;

  @Input() defaultValue: Item;

  @Input() disabled = false;

  @Input() formControl: FormControl;

  @Output() valueChange = new EventEmitter();

  // hiddenInput = new FormControl('');
  @ViewChild('selectInput', {static: false}) input: ElementRef;
  @ViewChild('dropdownOptions', {static: false}) dropdownOptions: ElementRef;
  val: string;

  get value() {
    return this.val;
  }

  set value(val) {
    this.val = val;
    this.onChange(val);
    this.onTouched();
    this.valueChange.emit(val);
  }


  // Both onChange and onTouched are functions
  onChange: any = () => {};
  onTouched: any = () => { };
  setDisabled: any = () => { };

  constructor(private renderer: Renderer2) {
  }
  ngOnInit() {

  }
  ngOnChanges(changes) {
    if (changes.objects && changes.objects.previousValue && changes.objects.previousValue.length === 0) {
      // deal with asynchronous Observable result
      this.writeValue(this.val);
    }
  }

  ngAfterViewInit() {
    this.renderer.setProperty(this.input.nativeElement, 'value', this.val);
  }

  /**
   * Method called when an option has been selected in the dropdown
   */
  selectOption(value) {
    if (this.input) {
      this.renderer.setProperty(this.input.nativeElement, 'value', value);
    }
    this.value = value;
    this.selectedOption = this.objects.find(item => item.value === value);

    if ( this.formControl ) {
      this.formControl.markAsDirty();
    }
  }

  // We implement this method to keep a reference to the onChange
  // callback function passed by the forms API
  registerOnChange(fn) {
    this.onChange = fn;
  }
  // We implement this method to keep a reference to the onTouched
  // callback function passed by the forms API
  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  // This is a basic setter that the forms API is going to use
  writeValue(value) {
    // console.log(value);
    if (value) {
      if (this.input) {
        this.renderer.setProperty(this.input.nativeElement, 'value', value);
      }
      this.value = value;
      if (this.objects) {
        this.selectedOption = this.objects.find(item => item.value === value);
      }
    }
  }

  blurred(event_name) {
    if ( this.formControl && (event_name !== 'mouseout' || this.isiOS() ) ) {
      this.formControl.markAsTouched();
    }
  }

  isiOS() { return navigator.userAgent.match(/ipad|ipod|iphone/i); }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

}
